/**
 * Scrolls the page back to the top: resets every scrollable ancestor of
 * `element` (layouts scroll inside `<main className="overflow-y-auto">`,
 * not the window) as well as the window itself.
 */
export const scrollToTop = (element?: Element | null): void => {
  let node = element?.parentElement ?? null;
  while (node) {
    if (node.scrollTop > 0) node.scrollTop = 0;
    node = node.parentElement;
  }
  window.scrollTo({ top: 0 });
};
